import NPSForm from '@/components/NPSForm.vue';
import IntermediateScreen from '@/components/IntermediateScreen.vue';
import InternalForm from '@/components/InternalForm.vue';
import ThankYouPage from '@/components/ThankYouPage.vue';
import NotFound from '@/components/NotFound.vue';

// Route configuration for public section
const publicRoutes = [
  { 
    path: '/', 
    name: 'root',
    redirect: { name: 'login' }
  },
  { 
    path: '/login', 
    name: 'login', 
    component: () => import('@/components/LoginPage.vue')
  },
  { 
    path: '/logout', 
    name: 'logout',
    component: () => import('@/components/LogoutPage.vue')
  },
  { 
    path: '/forgot-password', 
    name: 'forgot-password', 
    component: () => import('@/components/ForgotPassword.vue')
  },
  { 
    path: '/reset-password', 
    name: 'reset-password', 
    component: () => import('@/components/ResetPassword.vue')
  },
  // Rota para iniciar um trial
  // {
  //   path: '/register',
  //   name: 'register-trial',
  //   component: () => import('@/modules/public-forms/views/TrialRegistration.vue')
  // },
  {
    path: '/s/:slug/:branch?',
    name: 'nps-form-slug',
    component: NPSForm,
    props: true,
    beforeEnter: (to, from, next) => {
      const slug = to.params.slug;
      const branch = to.params.branch;
      
      if (!slug || !/^[a-z2-9]{3}$/.test(slug)) {
        next({ name: 'not-found' });
        return;
      }
      
      if (branch !== undefined && branch !== '') {
        if (!/^\d+$/.test(branch)) {
          next({ name: 'not-found' });
          return;
        }
      }
      
      next();
    }
  },
  {
    path: '/c/:custom_link/:branch?',
    name: 'nps-form-custom-link',
    component: NPSForm,
    props: true,
    beforeEnter: (to, from, next) => {
      const customLink = to.params.custom_link;
      const branch = to.params.branch;
      
      if (!customLink || !/^[a-zA-Z0-9-_]{3,50}$/.test(customLink)) {
        next({ name: 'not-found' });
        return;
      }
      
      if (branch !== undefined && branch !== '') {
        if (!/^\d+$/.test(branch)) {
          next({ name: 'not-found' });
          return;
        }
      }
      
      next();
    }
  },
  { 
    path: '/intermediate', 
    name: 'IntermediateScreen', 
    component: IntermediateScreen, 
    props: route => ({ link: route.query.link })
  },
  { 
    path: '/internal-form', 
    name: 'InternalForm', 
    component: InternalForm,   
    props: route => ({ nps: Number(route.query.nps) })
  },
  {
    path: '/report/:uuid',
    name: 'PublicReport',
    component: () => import('@/modules/public-forms/views/PublicReportView.vue'),
    props: true
  },
  { 
    path: '/thank-you', 
    name: 'ThankYouPage', 
    component: ThankYouPage
  },
  // Nova rota para checkout público
  // {
  //   path: '/checkout/:planId?',
  //   name: 'public-checkout',
  //   component: () => import('@/modules/public-forms/views/PublicCheckout.vue'),
  //   props: true
  // },
  { 
    path: '/not-found', 
    name: 'not-found', 
    component: NotFound 
  },
  { 
    path: '/:catchAll(.*)*', 
    name: 'catch-all',
    beforeEnter: (to, from, next) => {
      next({ name: 'not-found', replace: true });
    }
  }
];

export default publicRoutes;